import { ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { PaymentMethodOptions } from '@stripe/stripe-js';
import { convertToCents } from '@frontend/currency';
import {
  stripeAppearance as appearance,
  PaymentConfigName,
  StripeConfigLocationType,
  usePaymentMethodConfig,
  useStripePromise,
} from '@frontend/payments-stripe-wrapper';

const achPaymentMethodOptions: PaymentMethodOptions = {
  us_bank_account: {
    financial_connections: {
      permissions: ['payment_method', 'balances'],
    },
  },
};

interface StripeElementsPortalWrapperProps {
  amount: number;
  onBehalfOf: string;
  children: ReactNode;
  isLive?: boolean;
  paymentConfigName?: PaymentConfigName;
  stripeKey?: string;
}

export const StripeElementsPortalWrapper = ({
  amount,
  onBehalfOf,
  paymentConfigName,
  children,
  stripeKey,
  isLive,
}: StripeElementsPortalWrapperProps) => {
  const { stripePromise } = useStripePromise(!!stripeKey ? { stripeExpressKey: stripeKey } : undefined);
  const paymentMethodConfiguration = usePaymentMethodConfig({
    paymentConfigName,
    locationType: isLive ? StripeConfigLocationType.Prod : StripeConfigLocationType.Dev,
  });

  return (
    <Elements
      stripe={stripePromise || null}
      options={{
        amount: convertToCents(amount || 50),
        setupFutureUsage: undefined,
        mode: 'payment',
        currency: 'usd',
        appearance,
        onBehalfOf: onBehalfOf,
        paymentMethodOptions: amount && amount >= 25000 ? achPaymentMethodOptions : undefined,
        paymentMethodConfiguration,
      }}
    >
      {children}
    </Elements>
  );
};
